import { ModelSagres } from "../model-sagres";

export class ArquivoRespostaAviso extends ModelSagres {
  Id: number;
  IdAviso: number;
  IdResposta: number;
  DataCriacao: Date;
  Nome: string;
  PathArquivo: string;
  Tamanho: number;
  Tipo: string;

  constructor(obj?: any) {
    super();
    if (obj) {
      this.Id = obj.Id;
      this.IdAviso = obj.IdAviso;
      this.IdResposta = obj.IdResposta;
      this.Nome = obj.Nome;
      this.PathArquivo = obj.PathArquivo;
      this.Tamanho = obj.Tamanho;
      this.Tipo = obj.Tipo;
      this.DataCriacao = new Date(obj.DataCriacao);
    }
  }
}
